package com.shadowings.gero

import org.koin.core.Koin
import org.koin.core.KoinApplication
import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration
import com.shadowings.gero.di.appModule
import com.shadowings.gero.domain.repository.AuthRepository
import com.shadowings.gero.domain.repository.CloudSyncRepository

private var _koin: Koin? = null

val koin: Koin
    get() = _koin ?: error("Koin not initialized")

fun initKoin(appDeclaration: KoinAppDeclaration = {}): KoinApplication {
    val koinApp = startKoin {
        appDeclaration()
        modules(appModule)
    }
    _koin = koinApp.koin
    // Resolve eagerly, right at boot: the Firebase authStateChanged listener (and its async
    // session restore) needs to start as early as possible — as a lazy single it wouldn't
    // construct until the first ViewModel needing it is created via koinViewModel(), which only
    // happens after the landing screen mounts, well after Firebase could have already resolved
    // the session. Done here (not via Koin's createdAtStart) so it only fires for real app boot,
    // not for AppModuleTest's koinApplication{} graph-validation instance.
    koinApp.koin.get<AuthRepository>()
    // Same reasoning for cloud sync: CloudSyncRepositoryImpl.startAutoSync() only used to run
    // once something injected CloudSyncRepository — in practice only ProfileViewModel does, so
    // stars/lessons stayed at their stale local DataStore values (e.g. 0 on web) until the user
    // opened the Profile tab, even though they were already logged in. Force it eagerly too.
    koinApp.koin.get<CloudSyncRepository>()
    return koinApp
}
